import api from './api';

const purchaseAnalysisService = {
  // Get purchase analysis data
  getPurchaseAnalysis: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.supplier) queryParams.append('supplier', params.supplier);
      if (params.category) queryParams.append('category', params.category);
      if (params.status) queryParams.append('status', params.status);

      const queryString = queryParams.toString();
      const url = `/purchase-analysis/analysis${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase analysis:', error);
      throw error;
    }
  },

  // Get filter options
  getFilterOptions: async () => {
    try {
      const response = await api.get('/purchase-analysis/filters');
      return response.data;
    } catch (error) {
      console.error('Error fetching filter options:', error);
      throw error;
    }
  }
};

export default purchaseAnalysisService;

